import newrelic from 'newrelic';

import { logger } from '@common/logger';

import { RequestError } from '../RequestError';
import { flattenObject } from './flattenObject';
import { getRuntimes } from './getRuntimes';

const WARNING_STATUSES = new Set([300, 401, 403, 404]);

/**
 *  Dear @hey-api/client-fetch,
 *  Just because we can throw anything as a error, doesn't mean we should
 */
export const getErrorInterceptor =
    (useNewRelic: boolean) =>
    (unknownError: unknown, response: Response | undefined, request: Request): RequestError => {
        const error = new RequestError(unknownError, response, request);
        const { isNodeRuntime } = getRuntimes();

        const attributes = flattenObject({
            request: request,
            response: response,
            'request.fullUrl': request.url,
        });

        if (error?.status && WARNING_STATUSES.has(error.status)) {
            logger.warn(error, attributes);
        } else {
            logger.error(error, attributes);
        }

        if (isNodeRuntime) {
            const expected = error.status === 404;
            if (useNewRelic) {
                newrelic.noticeError(error, attributes, expected);
            }
        }
        return error;
    };
